<template>
  <div class="login1">
    <div class="hd">
      <div class="logo">
        <div class="img" v-if="official_display"><img src="~@/assets/logo.png" /></div>
        <div class="text">
          <h1 v-if="official_display">Ai团餐</h1>
          <b v-if="official_display">|</b>
          <p>{{logoText}}</p>
        </div>
      </div>
      <div class="tel">
        咨询热线：<b class="fnum">400-0966-413</b>
      </div>
    </div>
    <div class="bd">
      <div class="fifo">
        <div class="figure">
          <img src="~@/assets/images/login-figure.png" />
        </div>
        <div class="tifo">
          <!-- <div class="con">
            <div class="title">
              <h1>账户登录</h1>
              <p>还没有账户，请与客服联系</p>
            </div>
            <div class="form">
              <a-form
                :form="form"
                @submit="handleSubmit"
              >
                <a-form-item>
                  <a-input
                    size="large"
                    v-decorator="['name',{rules: [{ required: true, message: '请输入用户名！' }]}]"
                    placeholder="用户名"
                  >
                    <icon-font
                      slot="prefix"
                      type="icon-yonghu"
                      class="in-icon"
                      style="color: rgba(0,0,0,.25)"
                    />
                  </a-input>
                </a-form-item>
                <a-form-item>
                  <a-input
                    size="large"
                    v-decorator="['pwd',{rules: [{ required: true, message: '请输入密码！' }]}]"
                    type="password"
                    placeholder="密码"
                  >
                    <icon-font
                      slot="prefix"
                      type="icon-mima"
                      class="in-icon"
                      style="color: rgba(0,0,0,.25)"
                    />
                  </a-input>
                </a-form-item>
                <div class="button">
                  <a-button
                    block
                    type="primary"
                    size="large"
                    html-type="submit"
                  >
                    登录
                  </a-button>
                </div>
              </a-form>
            </div>
          </div> -->
          <div class="con">
            <div class="wete">
              <p>Hello，欢迎光临！</p>
              <h1 class="ellipsis-l2">微信扫码登录</h1>
            </div>
            <div class="qrte">
              <div class="qr">
                <qrcode-vue
                  :value="qrcode"
                  size="160"
                  level="L"
                  foreground="#222"
                />
                <div class="expire" v-if="expire">
                  <div class="text">二维码已经过期<br />请点击刷新</div>
                  <div class="button">
                    <a-button type="primary" @click="getQrcode">刷新</a-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footer-component></footer-component>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
// import IconFont from '@/components/Iconfont'
import QrcodeVue from 'qrcode.vue'
import footerComponent from '@/components/Footer'
import apis from '@/business/apis'
export default {
  components: {
    // IconFont,
    QrcodeVue,
    footerComponent
  },
  data () {
    return {
      form: this.$form.createForm(this, { name: 'normal_login' }),
      logoText: '智慧食堂，就用Ai团餐',
      scene: 'k12',
      is_demo: false,
      qrcode: '',
      expire: true,
      official_display: true
    }
  },
  computed: {
    ...mapGetters('user', [
      'isTeacher'
    ])
  },
  methods: {
    ...mapActions('school', [
      'setCurrSchool',
      'setCurrOrg'
    ]),
    ...mapActions('user', [
      'saveCurrUser'
    ]),
    // handleSubmit (e) {
    //   e.preventDefault()
    //   this.form.validateFields((err, values) => {
    //     if (!err) {
    //       if (this.$route.params.orgCode) {
    //         this.orglogin(values)
    //       } else if (this.$route.params.schoolCode) {
    //         this.schoolLogin(values)
    //       } else {
    //         this.$message.info('url地址错误')
    //       }
    //     }
    //   })
    // },
    async orglogin (response) {
      // info.orgCode = this.$route.params.orgCode
      // const response = await this.$http.post(apis.orgAdmin.login, info)
      // if (!response.body.success) return

      response.body.organization.official_display = this.official_display
      response.body.organization.is_demo = this.is_demo
      await this.setCurrOrg(response.body.organization)
      response.body.user.isOrgAdmin = true
      await this.saveCurrUser(response.body.user)

      this.$router.push({
        name: 'SelectSchool'
      })
    },
    async schoolLogin (response) {
      // info.schoolCode = this.$route.params.schoolCode
      // const response = await this.$http.post(apis.schoolAdmin.login, info)
      // if (!response.body.success) return

      response.body.school.official_display = this.official_display
      response.body.school.is_demo = this.is_demo
      response.body.school.scene = this.scene
      await this.setCurrSchool(response.body.school)
      response.body.user.isOrgAdmin = false
      await this.saveCurrUser(response.body.user)

      let result = await this.$http.get(apis.studentGroup.count + response.body.school._id + '/count')
      if (!result.body.count) {
        this.$router.push({ name: 'ClassConfig' })
        return
      }
      if (this.isTeacher) {
        this.$router.push({ name: 'NutritionMonitorIndex' })
        return
      }
      result = await this.$http.get(apis.user.count + '?schoolId=' + response.body.school._id)
      if (!result.body.count) {
        this.$router.push({ name: 'FileManage' })
        return
      }
      this.$router.push({ name: 'NutritionMonitorIndex' })
    },
    async getQrcode () {
      const ecode = this.$route.params.orgCode || this.$route.params.schoolCode
      if (!ecode) {
        this.$message.info('url地址错误')
        return
      }
      const isOrg = !!this.$route.params.orgCode
      let cid = '5ff6c1f52ad06e0011b23bf6'
      if (window.location.host === 'canteen-k12.botwave.net') {
        cid = '5f59eefd8680920188948237'
      }
      const response = await this.$http.post(apis.gate.genQrcode)
      const key = response.body
      this.qrcode = `https://${window.location.host}/wechat/${cid}/login-auth/${key}/${ecode}/${isOrg}`
      this.expire = false

      try {
        const response = await this.$http.post(apis.gate.qrcodeScanned, {
          key
        })
        const ssoCode = response.body
        if (ssoCode) {
          const response = await this.$http.post(apis.gate.sso, {
            code: ssoCode,
            orgCode: this.$route.params.orgCode,
            schoolCode: this.$route.params.schoolCode
          })
          const r = response.body
          if (r.success) {
            if (this.$route.params.orgCode) {
              this.orglogin(response)
            } else {
              this.schoolLogin(response)
            }
          } else {
            this.expire = true
          }
        } else {
          this.expire = true
        }
      } catch (error) {
        console.log(error)
        this.$message.error(error.msg)
        this.expire = true
      }
    }
  },
  async mounted () {
    // this.form = this.$form.createForm(this, { name: 'normal_login' })
    let url = ''
    if (this.$route.params.orgCode) {
      url = apis.organization.orgName + this.$route.params.orgCode
    } else if (this.$route.params.schoolCode) {
      url = apis.school.schoolName + this.$route.params.schoolCode
    }
    if (url) {
      const response = await this.$http.get(url)
      if (response && response.body) {
        this.logoText = response.body.name || this.logoText
        this.official_display = response.body.official_display
        this.scene = response.body.scene
        this.is_demo = response.body.is_demo
      }
    }
    await this.setCurrOrg({ official_display: this.official_display })
    this.getQrcode()
  }
}
</script>
<style lang="less">
.login1 {
  > .hd {
    padding: 20px 40px;
    display: flex;
    align-items: center;
    > .logo {
      flex: 1;
      display: flex;
      align-items: center;
      .img {
        margin-top: -4px;
        width: 28px;
        img {
          width: 100%;
        }
      }
      .text {
        margin-left: 4px;
        line-height: 1;
        display: flex;
        align-items: center;
        h1 {
          font-size: 22px;
          font-weight: bold;
          margin: 0;
        }
        b {
          font-weight: normal;
          margin: 0 8px;
        }
        p {
          margin: 0;
        }
      }
    }
    .tel {
      display: flex;
      align-items: center;
      .fnum {
        font-size: 20px;
      }
    }
  }
  > .bd {
    padding: 100px 0 100px;
    background-color: #f2f2f2;
    background: url(../assets/images/bg.jpg);
    background-size: cover;
    background-position: center;
    .fifo {
      width: 980px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      .figure {
        flex: 1;
        margin-right: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: 100%;
        }
      }
      .tifo {
        width: 360px;
        height: 400px;
        background-color: #fff;
        box-shadow: 0 0 28px rgba(0, 0, 0, 0.1);
        border-radius: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        .con {
          padding: 0 20px;
          .wete {
            margin-bottom: 20px;
            line-height: 1.2;
            p {
              margin: 0;
              font-size: 14px;
              color: #9a9a9a;
            }
            h1 {
              font-weight: bold;
              font-size: 28px;
              margin: 8px 0 0;
            }
          }
          .qrte {
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            .qr {
              display: flex;
              align-items: center;
              justify-content: center;
              border: 1px solid #e8e8e8;
              padding: 8px;
              position: relative;
              > div {
                height: 160px;
              }
              .expire {
                position: absolute;
                z-index: 1;
                top: 0;
                bottom: 0;
                left: 0;
                right: 0;
                height: 170px;
                background: rgba(255, 255, 255, 0.95);
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: column;
                text-align: center;
                .text {
                }
                .button {
                  margin-top: 8px;
                  .ant-btn {
                    width: 100px;
                  }
                }
              }
            }
            .text {
              margin-top: 20px;
            }
          }
        }
      }
    }
  }
}
</style>
